import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/arrow_down2.svg'


const _withScopeId = n => (_pushScopeId("data-v-dd2da5ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-cy": "vendor-assessment-heading" }
const _hoisted_2 = ["id", "data-cy"]
const _hoisted_3 = { class: "tw-flex tw-flex-row tw-justify-start tw-items-center tw-py-[20px]" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_5 = {
  class: "tw-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58]",
  "data-cy": "vendor-assessment-question-name"
}
const _hoisted_6 = { class: "tw-flex tw-items-center tw-gap-[15px]" }
const _hoisted_7 = { class: "tw-text-[#B7B7B7] tw-text-[11px] tw-leading-[130%]" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "float-right button-arrow dropdown-button-arrow-img" }
const _hoisted_11 = {
  key: 0,
  class: "dropdown-button-arrow-img",
  src: _imports_0
}
const _hoisted_12 = {
  key: 1,
  class: "collap-button-arrow-down-img",
  src: _imports_0
}
const _hoisted_13 = ["id"]

import { computed, Ref, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import CustomCheckbox from "../common/customCheckBox.vue";
import AssessmentQuestionAttachmentsRequired from "../assessments/assessmentQuestionAttachmentsRequired.vue";
import AssessmentQuestionYesNo from "../assessments/assessmentQuestionYesNo.vue";
import AssessmentQuestionTextArea from "../assessments/assessmentQuestionTextArea.vue";
import {
  COMPLIANCE_TYPE,
  RIGHT_SLIDE_MODAL_NAME,
  MODAL_NAME,
  successStatusCodes,
  CHECKLIST_TYPE,
} from "@/utils/constants";
import store from "@/store";
import { IChecklistRequestedComplianceTypeValue } from "@/interfaces/vendor";
import { IModalMessage } from "@/interfaces/common/common";
import {
  deleteChecklistRequestedAttachment,
  IParamsUpdateChecklistRequestedItems,
  updateChecklistRequestedExternalItem,
} from "@/services/vendor";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { showErrorAPI } from "@/services/apiRoutes";
import { Vendor } from "@/services/apiRoutes/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentQuestionsDetail',
  props: {
  /** The order number of sub question category */
  orderNumber: {
    type: Number,
    default: 1,
  },
  /** sub sub categories */
  isExclude: {
    type: Boolean,
    default: false,
  },
  assessmentQuestion: {
    type: Object,
    default: () => ({}),
    required: true,
  },
  selectedQuestions: {
    type: Array as () => number[],
    default: () => [],
  },
  complianceTypeValues: {
    type: Array as () => IChecklistRequestedComplianceTypeValue[],
    default: () => [],
  },
  dataVendor: {
    type: Object,
    default: () => ({}),
  },
  idxHeading: {
    type: Number,
    default: 0,
  },
},
  emits: ["update:selected-questions"],
  setup(__props, { emit: emits }) {

const props = __props;





const selectAll: Ref<boolean> = computed(() => {
  if (props.assessmentQuestion.checklistItemChildren?.length) {
    const isSelect = props.assessmentQuestion.checklistItemChildren?.every(
      (item) => props.selectedQuestions.includes(item.itemMasterId),
    );

    const isExitsSeleted = props.selectedQuestions.includes(
      props.assessmentQuestion?.itemMasterId,
    );
    if (!isExitsSeleted && isSelect) {
      handleSelfCheck();
    }

    return isSelect;
  } else {
    return props.selectedQuestions.includes(
      props.assessmentQuestion.itemMasterId,
    );
  }
});

const showIcon: Ref<boolean> = ref(true);

const collapseCategory = () => (showIcon.value = !showIcon.value);

const handleSelfCheck = () => {
  emits("update:selected-questions", {
    item: props.assessmentQuestion,
    selected: selectAll.value,
    level: 0,
  });
};

const handleUpdateChecklist = (value: any) => {
  store.dispatch("Vendor/updateVendorRequestedExternalInput", value);
};

const showAdvanceModal = (item: any, parent, passkey) => {
  const checklistRequestedId =
    store.state.Vendor.checklistVendorRequestedExternalInput
      .checklistRequestedId;

  const emitData: IModalMessage = {
    component: RIGHT_SLIDE_MODAL_NAME.ASSESSMENT_REQUESTED_ADVANCED,
    properties: {
      checklistId: checklistRequestedId,
      checklistItemId: item.checklistItemId,
      questionData: {
        ...item,
        checklistItemCategoryLabel:
          parent.checklistItemHeadingLabel || parent.checklistItemName || "",
      },
      checklistType: CHECKLIST_TYPE.externalChecklist,
      passkey,
    },
    events: {
      "update:selected-questions": (data) => {
        emits("update:selected-questions", data);
      },
    },
  };
  eventEmitter.emit(EmitterEvents.OPEN_RIGHT_SLIDE_MODAL, emitData);
};

const handleUpdateItems = async (item: any) => {
  const checklistRequestedId: number = props.dataVendor.checklistRequestedId;

  try {
    if (item.checklistItemComplianceTypeId !== COMPLIANCE_TYPE.ATTACH) {
      let updatCheckListParams: IParamsUpdateChecklistRequestedItems = {
        checklistRequestedItems: [],
      };
      if (item.checklistItemComplianceTypeId === COMPLIANCE_TYPE.YES_NO) {
        updatCheckListParams = {
          checklistRequestedItems: [
            {
              checklistRequestedItemId: item.checklistItemId,
              complianceTypeValueId: null,
            },
          ],
        };
      }
      if (item.checklistItemComplianceTypeId === COMPLIANCE_TYPE.TEXT) {
        updatCheckListParams = {
          checklistRequestedItems: [
            {
              checklistRequestedItemId: item.checklistItemId,
              compensatingControlDescription: "",
            },
          ],
        };
      }
      const res = await updateChecklistRequestedExternalItem(
        checklistRequestedId,
        updatCheckListParams,
      );
      if (res.status === successStatusCodes.OK) {
        await store.dispatch("Vendor/fetchVendorRequestedExternalInput");
        // update this question
        eventEmitter.emit(EmitterEvents.CLOSE_MODAL);
      }
    } else {
      const attachmentIds = item.checklistItemAttachments.map(
        (attachment: any) => attachment.attachmentId,
      );

      if (attachmentIds.length) {
        const res = await deleteChecklistRequestedAttachment({
          checklistItemId: item.checklistItemId,
          checklistRequestedId: checklistRequestedId,
          checklistItemAttachmentIds: attachmentIds,
        });
        if (res.status === successStatusCodes.OK) {
          await store.dispatch("Vendor/fetchVendorRequestedExternalInput");
          // update this question
          eventEmitter.emit(EmitterEvents.CLOSE_MODAL);
        }
      }
    }
  } catch (error) {
    showErrorAPI(error, Vendor.putChecklistRequestedExternalItem);
  }
};

const showModalResetAnswers = (item: any) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-component-assessments-question-bulk-action-item-reset-answer-1",
      ),
      description: getComponentUiText(
        "app-assessment-modal-reset-answer-description-1",
      ),
      hiddenHelp: false,
      buttonText: getComponentUiText(
        "app-assessment-modal-reset-answers-button-text-1",
      ),
      buttonRed: true,
      class: "tw-top-[0px]",
    },
    events: {
      "update:data": () => {
        handleUpdateItems(item);
      },
    },
  };
  eventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.assessmentQuestion.checklistItemIsHeading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: `vendor-assessment-question-detail-heading-${__props.assessmentQuestion.itemMasterId}`,
          "data-cy": `assessment-question-attachment-${__props.idxHeading}`,
          class: _normalizeClass(`tw-cursor-pointer tw-select-none tw-pr-[25px] tw-bg-[#FCFCFD] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-self-stretch tw-border-0 tw-border-b-[1px] tw-border-solid tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-border-[#EFF0F1]`),
          onClick: collapseCategory
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(CustomCheckbox, {
              "is-checked": selectAll.value,
              "onUpdate:isChecked": [
                _cache[0] || (_cache[0] = ($event: any) => ((selectAll).value = $event)),
                handleSelfCheck
              ],
              class: "tw-h-[20px] tw-ml-[25px] !tw-mb-0",
              size: "20px"
            }, null, 8, ["is-checked"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(__props.assessmentQuestion.checklistItemHeadingLabel ||
              __props.assessmentQuestion.checklistItemName ||
              ""), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (!__props.assessmentQuestion?.checklistItemChildren)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)("app-component-assessments-no-question-1")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("span", null, _toDisplayString(`${__props.assessmentQuestion.checklistItemChildren?.length} `), 1),
                    _createElementVNode("span", null, _toDisplayString(__props.assessmentQuestion.checklistItemChildren?.length > 1
                ? _unref(getComponentUiText)(
                    "app-component-assessments-multiple-question-counter-1",
                  )
                : _unref(getComponentUiText)(
                    "app-component-assessments-single-question-counter-1",
                  )), 1)
                  ]))
            ]),
            _createElementVNode("span", _hoisted_10, [
              (showIcon.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : (_openBlock(), _createElementBlock("img", _hoisted_12))
            ])
          ])
        ], 10, _hoisted_2))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.assessmentQuestion.checklistItemChildren, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          id: `vendor-assessment-question-detail-item-${item.checklistItemId}`,
          key: item.checklistItemDateUpdatedEmailGrant
        }, [
          (item.checklistItemComplianceTypeId === _unref(COMPLIANCE_TYPE).ATTACH)
            ? (_openBlock(), _createBlock(AssessmentQuestionAttachmentsRequired, {
                key: 0,
                "is-show-required-tag": false,
                idx: __props.idxHeading + '-' + (idx + 1),
                "checklist-item": item,
                "selected-questions": __props.selectedQuestions,
                parent: __props.assessmentQuestion,
                "is-selected-all": selectAll.value,
                "onUpdate:selectedQuestions": _cache[1] || (_cache[1] = ($event: any) => (
            emits('update:selected-questions', $event)
          )),
                "onUpdate:answer": handleUpdateChecklist,
                onShowAdvanceModal: 
            (passkey) => showAdvanceModal(item, __props.assessmentQuestion, passkey)
          ,
                onOpenReset: ($event: any) => (showModalResetAnswers(item))
              }, null, 8, ["idx", "checklist-item", "selected-questions", "parent", "is-selected-all", "onShowAdvanceModal", "onOpenReset"]))
            : _createCommentVNode("", true),
          (item.checklistItemComplianceTypeId === _unref(COMPLIANCE_TYPE).YES_NO)
            ? (_openBlock(), _createBlock(AssessmentQuestionYesNo, {
                key: 1,
                "checklist-item": item,
                idx: __props.idxHeading + '-' + (idx + 1),
                "is-show-required-tag": false,
                "is-selected-all": selectAll.value,
                "selected-questions": __props.selectedQuestions,
                "is-vendor-request": _unref(CHECKLIST_TYPE).externalChecklist,
                "compliance-type-value": 
            __props.complianceTypeValues.find(
              (i) => i.id === item.checklistItemComplianceTypeId,
            )
          ,
                "onUpdate:selected": _cache[2] || (_cache[2] = (value) => (selectAll.value = value)),
                "onUpdate:selectedQuestions": _cache[3] || (_cache[3] = ($event: any) => (
            emits('update:selected-questions', $event)
          )),
                "onUpdate:answer": handleUpdateChecklist,
                onShowAdvanceModal: 
            (passkey) => showAdvanceModal(item, __props.assessmentQuestion, passkey)
          ,
                onOpenReset: ($event: any) => (showModalResetAnswers(item))
              }, null, 8, ["checklist-item", "idx", "is-selected-all", "selected-questions", "is-vendor-request", "compliance-type-value", "onShowAdvanceModal", "onOpenReset"]))
            : _createCommentVNode("", true),
          (item.checklistItemComplianceTypeId === _unref(COMPLIANCE_TYPE).TEXT)
            ? (_openBlock(), _createBlock(AssessmentQuestionTextArea, {
                key: 2,
                "checklist-item": item,
                "is-vendor-request": _unref(CHECKLIST_TYPE).externalChecklist,
                "is-show-required-tag": false,
                "is-selected-all": selectAll.value,
                idx: __props.idxHeading + '-' + (idx + 1),
                placeholder: 
            _unref(getComponentUiText)(
              'app-assessments-vendor-questions-placeholder-add-detail-1',
            )
          ,
                "selected-questions": __props.selectedQuestions,
                "onUpdate:selectedQuestions": _cache[4] || (_cache[4] = ($event: any) => (
            emits('update:selected-questions', $event)
          )),
                "onUpdate:answer": handleUpdateChecklist,
                onShowAdvanceModal: 
            (passkey) => showAdvanceModal(item, __props.assessmentQuestion, passkey)
          ,
                onOpenReset: ($event: any) => (showModalResetAnswers(item))
              }, null, 8, ["checklist-item", "is-vendor-request", "is-selected-all", "idx", "placeholder", "selected-questions", "onShowAdvanceModal", "onOpenReset"]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_13))
      }), 128))
    ], 512), [
      [_vShow, !showIcon.value]
    ])
  ]))
}
}

})